module.exports = __webpack_public_path__ + "static/media/Logo-RL_black.a87f4a09.png";